import { render, staticRenderFns } from "./TabUpgradeDetail.vue?vue&type=template&id=b4580220&"
import script from "./TabUpgradeDetail.vue?vue&type=script&lang=js&"
export * from "./TabUpgradeDetail.vue?vue&type=script&lang=js&"
import style0 from "./TabUpgradeDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports